module.exports = __webpack_public_path__ + "static/RooBot-9e6e33f84a34e61527489cd95518b7f1.png";